import { Outlet } from 'react-router-dom';

const Markup = props => {
  return (      
    <Outlet/>    
  );
}
  
// export default Test;
export default Markup;